import { render } from "./TagDisplay.vue?vue&type=template&id=16657f26"
import script from "./TagDisplay.vue?vue&type=script&lang=js"
export * from "./TagDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__